
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import SettlementTracker from './components/SettlementTracker';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <SettlementTracker />
      <Services />
      <WhyChooseUs />
      <ContactCTA />
      <Footer />
    </div>
  );
}
